import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { google_address_components } from 'src/app/enums/google-address.enum';
import { IAnswer, IApplication } from 'src/app/models/application-form/application-form.model';
/// <reference types="@types/googlemaps" />

@Component({
  selector: 'appform-contact-info-questions',
  templateUrl: './contact-info-questions.component.html',
  styleUrls: ['./contact-info-questions.component.css']
})

export class ContactInfoQuestionsComponent implements OnInit {

  private static QUESTION_SET_CODE = 'progressive_commercial_contact';
  private static GOOGLE_QUESTION_CODE = 'progressive_commercial_address_1';
  private static CITY_QUESTION_CODE = 'progressive_commercial_city';
  private static ZIPCODE_QUESTION_CODE = 'progressive_commercial_zipcode';
  private static STATE_QUESTION_CODE = 'progressive_commercial_state';
  private static JORNAYA_LEAD_ID = 'progressive_commercial_jornaya_lead_id';
  private static StreetNumber = '';
  @Output() answerUpdate = new EventEmitter<IAnswer>();
  @Input() formData: IApplication;
  @Input() readOnly: boolean;
  public answers: IAnswer[];
  public nameAnswers: IAnswer[];
  public generalAnswers: IAnswer[];
  public isSafeToShow = false;
  public addressAnswers: IAnswer[] = [];

  ngOnInit(): void {
    const questionSet = this.formData.questionSets.list.find(queSet => queSet.question_set.code === ContactInfoQuestionsComponent.QUESTION_SET_CODE);
    if (questionSet) {
      this.answers = questionSet.answers;
      const nameGroups = questionSet.question_set.question_groups.find(set => set.group_type === 'full_name');
      const addressGroups = questionSet.question_set.question_groups.find(set => set.group_type === 'address');
      this.nameAnswers = this.answers.filter(ans => nameGroups.question_ids.includes(ans.question.id));
      this.addressAnswers = this.answers.filter(ans => addressGroups.question_ids.includes(ans.question.id));
      this.generalAnswers = this.answers.filter(ans => !(nameGroups.question_ids.includes(ans.question.id) || addressGroups.question_ids.includes(ans.question.id)) && ans.question.code !== ContactInfoQuestionsComponent.JORNAYA_LEAD_ID);
      if (this.nameAnswers.length === 3 && this.addressAnswers.length >= 5) {
        this.isSafeToShow = true;
      }
    }
  }
  private updateAddressAnswers() {
    const questionSet = this.formData.questionSets.list.find(queSet => queSet.question_set.code === ContactInfoQuestionsComponent.QUESTION_SET_CODE);
    if (questionSet) {
      this.answers = questionSet.answers;
      const addressGroups = questionSet.question_set.question_groups.filter(set => set.group_type === 'address')[0];
      this.addressAnswers = this.answers.filter(ans => addressGroups.question_ids.includes(ans.question.id));
    }
  }
  public updateGooglePlace(event: google.maps.places.PlaceResult): void {

    for (const component of event.address_components) {
      const componentType = component.types[0];
      switch (componentType) {
        case google_address_components.STREET_NUMBER: {
          ContactInfoQuestionsComponent.StreetNumber = component.short_name;
          break;
        }
        case google_address_components.ROUTE: {
          const data = {
            question_id: this.answers.find(ans => ans.question.code === ContactInfoQuestionsComponent.GOOGLE_QUESTION_CODE).question.id,
            answer_id: this.answers.find(ans => ans.question.code === ContactInfoQuestionsComponent.GOOGLE_QUESTION_CODE).id,
            code: ContactInfoQuestionsComponent.GOOGLE_QUESTION_CODE,
            field_type: 'text',
            value: ContactInfoQuestionsComponent.StreetNumber + ' ' + component.short_name,
            invalid: false
          };
          const answer = this.updateAnswer(data);
          this.answerUpdate.emit(answer);
          break;

        }
        case google_address_components.POSTAL_CODE: {
          const data = {
            question_id: this.answers.find(ans => ans.question.code === ContactInfoQuestionsComponent.ZIPCODE_QUESTION_CODE).question.id,
            answer_id: this.answers.find(ans => ans.question.code === ContactInfoQuestionsComponent.ZIPCODE_QUESTION_CODE).id,
            code: ContactInfoQuestionsComponent.ZIPCODE_QUESTION_CODE,
            field_type: 'text',
            value: component.long_name,
            invalid: false
          };
          const answer = this.updateAnswer(data);
          this.answerUpdate.emit(answer);
          break;
        }
        case google_address_components.LOCALITY: {
          const data = {
            question_id: this.answers.find(ans => ans.question.code === ContactInfoQuestionsComponent.CITY_QUESTION_CODE).question.id,
            answer_id: this.answers.find(ans => ans.question.code === ContactInfoQuestionsComponent.CITY_QUESTION_CODE).id,
            code: ContactInfoQuestionsComponent.CITY_QUESTION_CODE,
            field_type: 'text',
            value: component.long_name,
            invalid: false
          };
          const answer = this.updateAnswer(data);
          this.answerUpdate.emit(answer);
          break;
        }
        case google_address_components.STATE: {
          const states = this.answers.find(ans => ans.question.code === ContactInfoQuestionsComponent.STATE_QUESTION_CODE).question.choices;
          const state = states.filter(stateName => stateName.alias === component.short_name);

          if (state) {
            const data = {
              question_id: this.answers.find(ans => ans.question.code === ContactInfoQuestionsComponent.STATE_QUESTION_CODE).question.id,
              answer_id: this.answers.find(ans => ans.question.code === ContactInfoQuestionsComponent.STATE_QUESTION_CODE).id,
              code: ContactInfoQuestionsComponent.STATE_QUESTION_CODE,
              field_type: 'dropdown',
              choice_id: state[0].id,
              invalid: false
            };
            const answer = this.updateAnswer(data);
            this.answerUpdate.emit(answer);
          }
          break;
        }
      }
    }
    this.updateAddressAnswers();
  }

  public onValueChanges(event): void {
    const answer = this.updateAnswer(event.data);
    this.answerUpdate.emit(answer);
  }

  private updateAnswer(data: any): IAnswer {
    const answer = this.formData.questionSets
      .list.find(queSet => queSet.question_set.code === ContactInfoQuestionsComponent.QUESTION_SET_CODE)
      .answers.find(ans => ans.question.code == data.code);
    const tempAns: IAnswer = { ...answer };
    switch (data.field_type) {
      case 'text':
      case 'phone':
      case 'email':
      case 'zipcode':
      case 'address':
        tempAns.value = data.value;
        break;
      case 'dropdown':
        tempAns.choice_id = data.choice_id;
        break;
      default:
        break;
    }
    tempAns.is_completed = !data.invalid;
    return tempAns;
  }

}
